var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAvg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: "48px",
    height: "48px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#64b5f6",
    d: "M31,14h13v-4c0-2.209-1.791-4-4-4h-9V14z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#bbdefb",
    d: "M40,6H14c-2.209,0-4,1.791-4,4v28c0,2.209,1.791,4,4,4h18c2.209,0,4-1.791,4-4V10 C36,7.791,37.791,6,40,6z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#64b5f6",
    d: "M32 42H8c-2.209 0-4-1.791-4-4v-3h24v3C28 40.209 29.791 42 32 42zM16 14H30V16H16zM16 19H26V21H16zM16 24H30V26H16zM16 29H26V31H16z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvg);
export default __webpack_public_path__ + "static/media/avg.eaeeb76e21850eff8db72e2d20883d9e.svg";
export { ForwardRef as ReactComponent };